<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We're sorry your quote wasn't what you expected.</h4>
  <p>
    If you'd like to talk to us about your contract, we can review your usage
    work out payments that you'd prefer. You just need to

    <Link class="link text-primary-600" :to="ExternalRoute.contactUs">
      get in touch with our customer support team here
    </Link>
    , or on
    <Link class="link text-primary-600" to="mailto:help@so.energy"
      >help@so.energy</Link
    >
    or
    <Link class="link text-primary-600" to="tel:0330 111 5050"
      >0330 111 5050</Link
    >
    (Mon-Fri 9am-5pm) and let us know the problem.
  </p>
  <p>
    If you have an issue with your opening meter reading or estimate
    <Link
      class="link text-primary-600"
      :to="ExternalRoute.wrongOMRSupportArticle"
    >
      please see our guide on how to resolve this
    </Link>
    .
  </p>
</template>
